module.exports = __webpack_public_path__ + "static/koenigsberg-sketch-fcd3895880e01b4ffb70cbe113b50938.png";